import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectAllCutReturnInlist, selectCutReturnlist } from '../../Selectors/Master/ItemSelectors';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { fetchAllCutReturnInhosuelist, fetchCuttingReturnlist } from '../../../Store/PHPSlice/Cutting/cuttingApi';



const CuttingFinalPrint = () => {
    const [formData, setFormData] = useState({
        dt: '',
        empNm: '',
        empType: '',
        cutId: '',
        reId: [],
        cutMemo: '',
        reMemo: '',
        itemId: '',
        itemNm: '',
        reQty: '',
        totQty: '',
        gMtr: '',
        actAvg: '',
        mcloth: '',
        mclothNm: '',
        m1cloth: '',
        m1clothNm: '',
        m2cloth: '',
        m2clothNm: '',
        m3cloth: '',
        m3clothNm: '',
        soId: '',
        sono: '',
        partyId: '',
        partyNm: '',
        schlNm: '',
        schlId: '',
        mavg: '0',
        m1avg: '0',
        m2avg: '0',
        m3avg: '0',
        mgmtr: '',
        m1gmtr: '',
        m2gmtr: '',
        m3gmtr: '',
        mreq: '',
        m1req: '',
        m2req: '',
        m3req: '',
        mused: '0',
        m1used: '0',
        m2used: '0',
        m3used: '0',
        mbal: '',
        m1bal: '',
        m2bal: '',
        m3bal: '',
        newMused: '',
        newM1used: '',
        newM2used: '',
        newM3used: '',
        new_mPanaAvg: '',
        new_m1PanaAvg: '',
        new_m2PanaAvg: '',
        new_m3PanaAvg: '',
        instruction: '',
        userId: '1'
    });
    const { Id } = useParams();
    const dispatch = useDispatch();
    const returnInfolist = useSelector(selectAllCutReturnInlist);
    const [tableData, setTableData] = useState([]);

    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed
    useEffect(() => {
        dispatch(fetchAllCutReturnInhosuelist(Id))
    }, [Id]);


    useEffect(() => {
        if (returnInfolist?.data) {
            const item = returnInfolist?.data;

            let inw_mpanaAvg = parseFloat(item.mused) / parseFloat(item.totReturnqty);
            let inw_m1panaAvg = parseFloat(item.m1used) / parseFloat(item.totReturnqty);
            let inw_m2panaAvg = parseFloat(item.m2used) / parseFloat(item.totReturnqty);
            let inw_m3panaAvg = parseFloat(item.m3used) / parseFloat(item.totReturnqty);

            let mbal = parseFloat(item.mgmtr) - parseFloat(item.mused);
            let m1bal = parseFloat(item.m1gmtr) - parseFloat(item.m1used);
            let m2bal = parseFloat(item.m2gmtr) - parseFloat(item.m2used);
            let m3bal = parseFloat(item.m3gmtr) - parseFloat(item.m3used);
            setFormData(prev => ({
                ...prev,
                empId: item.empId || '',
                empNm: item.empNm || '',
                empType: item.empType || '',
                itemId: item.itemId || '',
                itemNm: item.itemNm || '',
                totQty: item.totIssqty || '',
                reQty: item.totReturnqty || '',
                soId: item.soId || '',
                sono: item.sono || '',
                // partyId: item.partyId || '',
                // partyNm: item.partyNm || '',
                mcloth: item.mcloth || '',
                mclothNm: item.mclothNm || '',
                m1cloth: item.m1cloth || '',
                m1clothNm: item.m1clothNm || '',
                m2cloth: item.m2cloth || '',
                m2clothNm: item.m2clothNm || '',
                m3cloth: item.m3cloth || '',
                m3clothNm: item.m3clothNm || '',
                // schlId: item.schoolId,
                // schlNm: item.schoolNm,
                cutId: item.ctId,
                cutMemo: item.ctMemo,
                mreq: item.mreq,
                m1req: item.m1req,
                m2req: item.m2req,
                m3req: item.m3req,
                mgmtr: item.mgmtr,
                m1gmtr: item.m1gmtr,
                m2gmtr: item.m2gmtr,
                m3gmtr: item.m3gmtr,
                instruction: item.instruction,
                mused: item.mused,
                m1used: item.m1used,
                m2used: item.m2used,
                m3used: item.m3used,
                newMused: item.mused,
                newM1used: item.m1used,
                newM2used: item.m2used,
                newM3used: item.m3used,
                new_mPanaAvg: inw_mpanaAvg.toFixed(2),
                new_m1PanaAvg: inw_m1panaAvg.toFixed(2),
                new_m2PanaAvg: inw_m2panaAvg.toFixed(2),
                new_m3PanaAvg: inw_m3panaAvg.toFixed(2),
                mbal: mbal.toFixed(0),
                m1bal: m1bal.toFixed(0),
                m2bal: m2bal.toFixed(0),
                m3bal: m3bal.toFixed(0),
            }));

        }
        if (returnInfolist?.data2 && returnInfolist.data2?.length > 0) {
            const item = returnInfolist.data2;
            const dt = item.map(val => val.dt).join(',');
            const ctreMemo = item.map(val => val.ctreMemo).join(',');
            setFormData(prev => ({
                ...prev,
                reMemo: ctreMemo,
                dt: dt
            }));
        }
        if (returnInfolist?.returnInfo?.length > 0) {
            const data = returnInfolist.returnInfo;
            setTableData(data);
        }
    }, [returnInfolist]);


    // function InwardAverage(usedmtr, inwqtyarr) {
    //     let used = parseFloat(usedmtr);
    //     let inwqtylen = inwqtyarr.length;
    //     let update_used = used / inwqtylen;
    //     const avg = inwqtylen > 0 ? inwqtyarr.map(item => update_used / parseFloat(item.returnqty)) : [];
    //     return avg;
    // }
    // // Calculate averages dynamically inside the render
    // const calculatedInwardAvg = InwardAverage(formData.newMused, tableData);
    // const calculatedInwardAvg1 = InwardAverage(formData.newM1used, tableData);
    // const calculatedInwardAvg2 = InwardAverage(formData.newM2used, tableData);
    // const calculatedInwardAvg3 = InwardAverage(formData.newM3used, tableData);

    function InwardAverage(usedmtr, inwqtyarr) {
        let used = parseFloat(usedmtr);
        let inwqtylen = inwqtyarr.length;
        // let update_used = used / inwqtylen;
        let update_used = inwqtylen > 0 ? inwqtyarr.map(item => parseFloat(item.issqty) * parseFloat(item.mavg)) : [];
        console.log(update_used)

        const avg = inwqtylen > 0 ? inwqtyarr.map((item, index) => update_used[index] / (parseFloat(item.returnqty) + parseFloat(item?.dqty))) : [];
        return avg;
    }

    function InwardAverage1(usedmtr, inwqtyarr) {
        let used = parseFloat(usedmtr);
        let inwqtylen = inwqtyarr.length;
        // let update_used = used / inwqtylen;
        let update_used = inwqtylen > 0 ? inwqtyarr.map(item => parseFloat(item.issqty) * parseFloat(item.m1avg)) : [];
        console.log(update_used)

        const avg = inwqtylen > 0 ? inwqtyarr.map((item, index) => update_used[index] / (parseFloat(item.returnqty) + parseFloat(item?.dqty))) : [];
        return avg;
    }

    function InwardAverage2(usedmtr, inwqtyarr) {
        let used = parseFloat(usedmtr);
        let inwqtylen = inwqtyarr.length;
        // let update_used = used / inwqtylen;
        let update_used = inwqtylen > 0 ? inwqtyarr.map(item => parseFloat(item.issqty) * parseFloat(item.m2avg)) : [];
        console.log(update_used)

        const avg = inwqtylen > 0 ? inwqtyarr.map((item, index) => update_used[index] / (parseFloat(item.returnqty) + parseFloat(item?.dqty))) : [];
        return avg;
    }

    function InwardAverage3(usedmtr, inwqtyarr) {
        let used = parseFloat(usedmtr);
        let inwqtylen = inwqtyarr.length;
        // let update_used = used / inwqtylen;
        let update_used = inwqtylen > 0 ? inwqtyarr.map(item => parseFloat(item.issqty) * parseFloat(item.m3avg)) : [];
        console.log(update_used)

        const avg = inwqtylen > 0 ? inwqtyarr.map((item, index) => update_used[index] / (parseFloat(item.returnqty) + parseFloat(item?.dqty))) : [];
        return avg;
    }
    // console.log(tableData);
    // Calculate averages dynamically inside the render
    const calculatedInwardAvg = InwardAverage(formData.newMused, tableData);
    const calculatedInwardAvg1 = InwardAverage1(formData.newM1used, tableData);
    const calculatedInwardAvg2 = InwardAverage2(formData.newM2used, tableData);
    const calculatedInwardAvg3 = InwardAverage3(formData.newM3used, tableData);

    function pannaAvg(usedmtr, reqty) {
        let used = parseFloat(usedmtr);
        let qty = parseFloat(reqty);

        let calPannaAvg = used / qty;
        return calPannaAvg.toFixed(2);
    }

    const pannaAvg_maincloth = pannaAvg(formData.mused, formData.totQty);
    const pannaAvg_m1cloth = pannaAvg(formData.m1used, formData.totQty);
    const pannaAvg_m2cloth = pannaAvg(formData.m2used, formData.totQty);
    const pannaAvg_m3cloth = pannaAvg(formData.m3used, formData.totQty);

    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        // Allow only numbers and an optional empty string (to allow erasing the input)
        if (/^\d*$/.test(value)) {
            setFormData({
                ...formData,
                [name]: value, // Update the correct field in formData
            });
        }
        switch (name) {
            case 'mbal':
                if (value) {
                    let newMused = parseFloat(formData.mgmtr) - parseFloat(value);
                    let change_mPanaAvg = newMused / parseFloat(formData.reQty);
                    setFormData(prev => ({
                        ...prev,
                        newMused: newMused,
                        new_mPanaAvg: change_mPanaAvg.toFixed(2)
                    }));
                }
                break;
            case 'm1bal':
                if (value) {
                    let newM1used = parseFloat(formData.m1gmtr) - parseFloat(value);
                    let change_m1PanaAvg = newM1used / parseFloat(formData.reQty);
                    setFormData(prev => ({
                        ...prev,
                        newM1used: newM1used,
                        new_m1PanaAvg: change_m1PanaAvg.toFixed(2)
                    }));
                }
                break;
            case 'm2bal':
                if (value) {
                    let newM2used = parseFloat(formData.m2gmtr) - parseFloat(value);
                    let change_m2PanaAvg = newM2used / parseFloat(formData.reQty);
                    setFormData(prev => ({
                        ...prev,
                        newM2used: newM2used,
                        new_m2PanaAvg: change_m2PanaAvg.toFixed(2)
                    }));
                }
                break;
            case 'm3bal':
                if (value) {
                    let newM3used = parseFloat(formData.m3gmtr) - parseFloat(value);
                    let change_m3PanaAvg = newM3used / parseFloat(formData.reQty);
                    setFormData(prev => ({
                        ...prev,
                        newM3used: newM3used,
                        new_m3PanaAvg: change_m3PanaAvg.toFixed(2)
                    }));
                }
                break;
        }
    };
    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1% 0%', width: '100%' }} ref={componentRef}>

                        <h3 className='centered-heading'>Only Cutting - Inward Print</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '200px' }}>Master</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.empNm}</td>
                                    <td style={{ width: '200px' }}>Cutting Memo No.</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.cutMemo}</td>

                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Return Memo No.</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.reMemo}</td>

                                    <td style={{ width: '200px' }}>Date of Inward Issue</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.dt}</td>

                                </tr>

                                {formData.soId !== '0' &&
                                    <>
                                        <tr>
                                            <td style={{ width: '200px' }}>Sale Order No.</td>
                                            <td>:</td>
                                            <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.sono}</td>
                                            <td style={{ width: '200px' }}>Party</td>
                                            <td>:</td>
                                            <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.partyNm}</td>
                                        </tr>

                                        <tr>
                                            <td style={{ width: '200px' }}>School Name</td>
                                            <td>:</td>
                                            <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.schlNm}</td>

                                        </tr>
                                    </>

                                }
                                <tr>
                                    <td style={{ width: '200px' }}>Item</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.itemNm}</td>


                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Issue Total Qty.</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.totQty}</td>
                                    <td style={{ width: '200px' }}>Return Qty.</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.reQty}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Pending Qty.</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{parseFloat(formData.totQty) - parseFloat(formData.reQty) > 0 ? parseFloat(formData.totQty) - parseFloat(formData.reQty) : 0}</td>
                                    {/* <td style={{ width: '200px' }}>Panna Avg.</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{main_pannaAvg + m1_pannaAvg + m2_pannaAvg + m3_pannaAvg}</td> */}

                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Cutting Instructions</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.instruction}</td>


                                </tr>
                            </tbody>
                        </table>


                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '100px' }}>Main Cloth : </td>
                                    <td style={{ width: '25vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.mclothNm}</td>
                                    <td style={{ width: '120px' }}>Inw. Given Mtr. : </td>
                                    <td style={{ width: '8vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.mgmtr}</td>
                                    <td style={{ width: '120px' }}>Inw. Used Mtr. : </td>
                                    <td style={{ width: '8vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.newMused}</td>
                                    <td style={{ width: '120px' }}>Inw. Bal Mtr. : </td>
                                    <td style={{ width: '8vw', padding: ' 0.2%  1.5%' }} className='dark-color'>
                                        <input
                                            type="text"
                                            name='mbal'
                                            value={formData.mbal}
                                            onChange={handleInputChange} // Use the onChange function here
                                            style={{ width: '50px', outline: 'none', textAlign: 'center' }}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td style={{ width: '100px' }}> </td>
                                    <td style={{ width: '25vw', padding: ' 0.2%  1.5%' }} className='dark-color'> </td>
                                    <td style={{ width: '120px' }}>Issue Panna Avg. : </td>
                                    <td style={{ width: '8vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{pannaAvg_maincloth}</td>
                                    <td style={{ width: '120px' }}>Inw. Panna Avg. : </td>
                                    <td style={{ width: '8vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.new_mPanaAvg}</td>

                                </tr>

                            </tbody>
                        </table>

                        {formData.m1cloth !== '0' &&
                            <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                                <tbody>


                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-1 Cloth : </td>
                                        <td style={{ width: '25vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m1clothNm}</td>
                                        <td style={{ width: '120px' }}>Inw. Given Mtr. : </td>
                                        <td style={{ width: '8vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m1gmtr}</td>
                                        <td style={{ width: '120px' }}>Inw. Used Mtr. : </td>
                                        <td style={{ width: '8vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.newM1used}</td>
                                        <td style={{ width: '120px' }}>Inw. Bal Mtr. : </td>
                                        <td style={{ width: '8vw', padding: ' 0.2%  1.5%' }} className='dark-color'>
                                            <input
                                                type="text"
                                                name='m1bal'
                                                value={formData.m1bal}
                                                onChange={handleInputChange}  // Use the onChange function here
                                                style={{ width: '50px', outline: 'none', textAlign: 'center' }}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ width: '100px' }}> </td>
                                        <td style={{ width: '25vw', padding: ' 0.2%  1.5%' }} className='dark-color'> </td>
                                        <td style={{ width: '120px' }}>Issue Panna Avg. : </td>
                                        <td style={{ width: '8vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{pannaAvg_m1cloth}</td>
                                        <td style={{ width: '120px' }}>Inw. Panna Avg. : </td>
                                        <td style={{ width: '8vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.new_m1PanaAvg}</td>

                                    </tr>


                                </tbody>
                            </table>
                        }

                        {formData.m2cloth !== '0' &&
                            <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                                <tbody>


                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-2 Cloth</td>
                                        <td>:</td>
                                        <td style={{ width: '25vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m2clothNm}</td>
                                        <td style={{ width: '120px' }}>Inw. Given Mtr.</td>
                                        <td>:</td>
                                        <td style={{ width: '8vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m2gmtr}</td>
                                        <td style={{ width: '120px' }}>Inw. Used Mtr.</td>
                                        <td>:</td>
                                        <td style={{ width: '8vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.newM2used}</td>
                                        <td style={{ width: '120px' }}>Inw. Bal Mtr.</td>
                                        <td>:</td>
                                        <td style={{ width: '8vw', padding: ' 0.2%  1.5%' }} className='dark-color'>
                                            <input
                                                type="text"
                                                name='m2bal'
                                                value={formData.m2bal}
                                                onChange={handleInputChange}  // Use the onChange function here
                                                style={{ width: '50px', outline: 'none', textAlign: 'center' }}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ width: '100px' }}> </td>
                                        <td> </td>
                                        <td style={{ width: '25vw', padding: ' 0.2%  1.5%' }} className='dark-color'> </td>
                                        <td style={{ width: '120px' }}>Issue Panna Avg.</td>
                                        <td>:</td>
                                        <td style={{ width: '8vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{pannaAvg_m2cloth}</td>
                                        <td style={{ width: '120px' }}>Inw. Panna Avg.</td>
                                        <td>:</td>
                                        <td style={{ width: '8vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.new_m2PanaAvg}</td>

                                    </tr>


                                </tbody>
                            </table>
                        }

                        {formData.m3cloth !== '0' &&
                            <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                                <tbody>


                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-3 Cloth</td>
                                        <td>:</td>
                                        <td style={{ width: '25vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m3clothNm}</td>
                                        <td style={{ width: '120px' }}>Inw. Given Mtr.</td>
                                        <td>:</td>
                                        <td style={{ width: '8vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m3gmtr}</td>
                                        <td style={{ width: '120px' }}>Inw. Used Mtr.</td>
                                        <td>:</td>
                                        <td style={{ width: '8vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.newM3used}</td>
                                        <td style={{ width: '120px' }}>Inw. Bal Mtr.</td>
                                        <td>:</td>
                                        <td style={{ width: '8vw', padding: ' 0.2%  1.5%' }} className='dark-color'>
                                            <input
                                                type="text"
                                                name='m3bal'
                                                value={formData.m3bal}
                                                onChange={handleInputChange} // Use the onChange function here
                                                style={{ width: '50px', outline: 'none', textAlign: 'center' }}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ width: '100px' }}> </td>
                                        <td> </td>
                                        <td style={{ width: '25vw', padding: ' 0.2%  1.5%' }} className='dark-color'> </td>
                                        <td style={{ width: '120px' }}>Issue Panna Avg.</td>
                                        <td>:</td>
                                        <td style={{ width: '8vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{pannaAvg_m3cloth}</td>
                                        <td style={{ width: '120px' }}>Inw. Panna Avg.</td>
                                        <td>:</td>
                                        <td style={{ width: '8vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.new_m3PanaAvg}</td>

                                    </tr>


                                </tbody>
                            </table>
                        }

                        {/* <div style={{ marginBottom: '3vh' }}>
                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                <Table>

                                    <TableRow>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Particular</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Main Cloth</TableCell>
                                        {
                                            formData.m1cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Matching - 1</TableCell>
                                        }
                                        {
                                            formData.m2cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Matching - 2</TableCell>
                                        }
                                        {
                                            formData.m3cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Matching - 3</TableCell>
                                        }
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Cloth</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{formData.mclothNm}</TableCell>
                                        {
                                            formData.m1cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{formData.m1clothNm}</TableCell>
                                        }
                                        {
                                            formData.m2cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{formData.m2clothNm}</TableCell>
                                        }
                                        {
                                            formData.m3cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{formData.m3clothNm}</TableCell>
                                        }
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Given Mtr.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{formData.mgmtr}</TableCell>
                                        {
                                            formData.m1cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{formData.m1gmtr}</TableCell>
                                        }
                                        {
                                            formData.m2cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{formData.m2gmtr}</TableCell>
                                        }
                                        {
                                            formData.m3cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>{formData.m3gmtr}</TableCell>
                                        }
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Used Mtr.</TableCell>

                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <span>{formData.mused}</span>
                                                <span style={{ borderLeft: '1px solid #000', height: '1.5em', margin: '0 20%' }}></span>
                                                <span>{formData.newMused}</span>
                                            </div>
                                        </TableCell>
                                        {formData.m1cloth !== '0' &&

                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <span>{formData.m1used}</span>
                                                    <span style={{ borderLeft: '1px solid #000', height: '1.5em', margin: '0 20%' }}></span>
                                                    <span>{formData.newM1used}</span>
                                                </div>
                                            </TableCell>
                                        }

                                        {formData.m2cloth !== '0' &&

                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <span>{formData.m2used}</span>
                                                    <span style={{ borderLeft: '1px solid #000', height: '1.5em', margin: '0 20%' }}></span>
                                                    <span>{formData.newM2used}</span>
                                                </div>
                                            </TableCell>
                                        }

                                        {formData.m3cloth !== '0' &&

                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <span>{formData.m3used}</span>
                                                    <span style={{ borderLeft: '1px solid #000', height: '1.5em', margin: '0 20%' }}></span>
                                                    <span>{formData.newM3used}</span>
                                                </div>
                                            </TableCell>
                                        }

                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Bal Mtr.</TableCell>


                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <span>{balmtr_main}</span>
                                                <span style={{ borderLeft: '1px solid #000', height: '1.5em', margin: '0 20%' }}></span>
                                                <span>
                                                    <input
                                                        type="text"
                                                        name='mbal'
                                                        value={formData.mbal}
                                                        onChange={handleInputChange} // Use the onChange function here
                                                        style={{ width: '50px', outline: 'none', textAlign: 'center' }}
                                                    />

                                                </span>
                                            </div>
                                        </TableCell>

                                        {formData.m1cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <span>{balmtr_m1}</span>
                                                    <span style={{ borderLeft: '1px solid #000', height: '1.5em', margin: '0 20%' }}></span>
                                                    <span>
                                                        <input
                                                            type="text"
                                                            name='m1bal'
                                                            value={formData.m1bal}
                                                            onChange={handleInputChange}  // Use the onChange function here
                                                            style={{ width: '50px', outline: 'none', textAlign: 'center' }}
                                                        />

                                                    </span>
                                                </div>
                                            </TableCell>
                                        }

                                        {formData.m2cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <span>{balmtr_m2}</span>
                                                    <span style={{ borderLeft: '1px solid #000', height: '1.5em', margin: '0 20%' }}></span>
                                                    <span>
                                                        <input
                                                            type="text"
                                                            name='m2bal'
                                                            value={formData.m2bal}
                                                            onChange={handleInputChange}  // Use the onChange function here
                                                            style={{ width: '50px', outline: 'none', textAlign: 'center' }}
                                                        />

                                                    </span>
                                                </div>
                                            </TableCell>
                                        }
                                        {formData.m3cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <span>{balmtr_m3}</span>
                                                    <span style={{ borderLeft: '1px solid #000', height: '1.5em', margin: '0 20%' }}></span>
                                                    <span>
                                                        <input
                                                            type="text"
                                                            name='m3bal'
                                                            value={formData.m3bal}
                                                            onChange={handleInputChange} // Use the onChange function here
                                                            style={{ width: '50px', outline: 'none', textAlign: 'center' }}
                                                        />

                                                    </span>
                                                </div>
                                            </TableCell>
                                        }


                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>Panna Avg.</TableCell>

                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <span>{pannaAvg_maincloth}</span>
                                                <span style={{ borderLeft: '1px solid #000', height: '1.5em', margin: '0 20%' }}></span>
                                                <span>{formData.new_mPanaAvg}</span>
                                            </div>
                                        </TableCell>

                                        {formData.m1cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <span>{pannaAvg_m1cloth}</span>
                                                    <span style={{ borderLeft: '1px solid #000', height: '1.5em', margin: '0 20%' }}></span>
                                                    <span>{formData.new_m1PanaAvg}</span>
                                                </div>
                                            </TableCell>
                                        }

                                        {formData.m2cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <span>{pannaAvg_m2cloth}</span>
                                                    <span style={{ borderLeft: '1px solid #000', height: '1.5em', margin: '0 20%' }}></span>
                                                    <span>{formData.new_m2PanaAvg}</span>
                                                </div>
                                            </TableCell>
                                        }

                                        {formData.m3cloth !== '0' &&
                                            <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center'>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <span>{pannaAvg_m3cloth}</span>
                                                    <span style={{ borderLeft: '1px solid #000', height: '1.5em', margin: '0 20%' }}></span>
                                                    <span>{formData.new_m3PanaAvg}</span>
                                                </div>
                                            </TableCell>
                                        }
                                    </TableRow>
                                </Table>
                            </TableContainer>
                        </div> */}

                        {/* <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableRow>
                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center' className='tbl-row'>Size</TableCell>
                                    {Info_cuttinglist.map((item, index) => (
                                        <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.size}</TableCell>
                                    ))}
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Issue Qty.</TableCell>
                                    {Info_cuttinglist.map((item, index) => (
                                        <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.qty}</TableCell>
                                    ))}
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Inward Qty.</TableCell>
                                    {only_inwardqty.map((item, index) => (
                                        <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.rqty}</TableCell>
                                    ))}
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Damage Qty.</TableCell>
                                    {result.map((item, index) => (
                                        <TableCell key={index} sx={{ p: 1, border: '1px solid #000', color: 'red' }} align='center'>{item.Dqty}</TableCell>
                                    ))}

                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Main Avg.</TableCell>
                                    {Info_cuttinglist.map((item, index) => (
                                        <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.mavg}</TableCell>
                                    ))}
                                </TableRow>

                                <TableRow>
                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Inw. Main Avg.</TableCell>
                                    {calculatedInwardAvg.map((item, index) => {
                                        const mainAvg = Info_cuttinglist[index]?.mavg; // Ensure there's a corresponding value
                                        const inwMainAvg = item;

                                        // Determine the color based on the comparison
                                        const textColor = inwMainAvg <= mainAvg ? 'green' : 'red';

                                        return (
                                            <TableCell key={index} sx={{ p: 1, border: '1px solid #000', color: textColor }} align='center'>
                                                {inwMainAvg.toFixed(2)}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>


                                {formData.m1cloth !== '0' &&
                                    <>
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>M1 Avg.</TableCell>
                                            {Info_cuttinglist.map((item, index) => (
                                                <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.m1avg}</TableCell>
                                            ))}
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Inw. M1 Avg.</TableCell>
                                            {calculatedInwardAvg1.map((item, index) => {
                                                const m1Avg = Info_cuttinglist[index]?.m1avg; // Ensure there's a corresponding value
                                                const inwM1Avg = item;

                                                // Determine the color based on the comparison
                                                const textColor = inwM1Avg <= m1Avg ? 'green' : 'red';

                                                return (
                                                    <TableCell key={index} sx={{ p: 1, border: '1px solid #000', color: textColor }} align='center'>
                                                        {inwM1Avg.toFixed(2)}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    </>
                                }

                                {formData.m2cloth !== '0' &&
                                    <>
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>M2 Avg.</TableCell>
                                            {Info_cuttinglist.map((item, index) => (
                                                <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.m2avg}</TableCell>
                                            ))}
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Inw. M2 Avg.</TableCell>
                                            {calculatedInwardAvg2.map((item, index) => {
                                                const m2Avg = Info_cuttinglist[index]?.m2avg; // Ensure there's a corresponding value
                                                const inwM2Avg = item;

                                                // Determine the color based on the comparison
                                                const textColor = inwM2Avg <= m2Avg ? 'green' : 'red';

                                                return (
                                                    <TableCell key={index} sx={{ p: 1, border: '1px solid #000', color: textColor }} align='center'>
                                                        {inwM2Avg.toFixed(2)}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    </>
                                }

                                {formData.m3cloth !== '0' &&
                                    <>
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>M3 Avg.</TableCell>
                                            {Info_cuttinglist.map((item, index) => (
                                                <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.m3avg}</TableCell>
                                            ))}
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Inw. M3 Avg.</TableCell>
                                            {calculatedInwardAvg3.map((item, index) => {
                                                const m3Avg = Info_cuttinglist[index]?.m3avg; // Ensure there's a corresponding value
                                                const inwM3Avg = item;

                                                // Determine the color based on the comparison
                                                const textColor = inwM3Avg <= m3Avg ? 'green' : 'red';

                                                return (
                                                    <TableCell key={index} sx={{ p: 1, border: '1px solid #000', color: textColor }} align='center'>
                                                        {inwM3Avg.toFixed(2)}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    </>
                                }
                            </Table>
                        </TableContainer> */}


                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableRow>
                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '10vw' }} align='center' className='tbl-row'>Size</TableCell>
                                    {tableData.map((item, index) => (
                                        <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.size}</TableCell>
                                    ))}
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Issue Qty.</TableCell>
                                    {tableData.map((item, index) => (
                                        <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.issqty}</TableCell>
                                    ))}
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Inward Qty.</TableCell>
                                    {tableData.map((item, index) => (
                                        <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.returnqty}</TableCell>
                                    ))}
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Damage Qty.</TableCell>
                                    {tableData.map((item, index) => (
                                        <TableCell key={index} sx={{ p: 1, border: '1px solid #000', color: 'red' }} align='center'>{item.dqty}</TableCell>
                                    ))}

                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Main Avg.</TableCell>
                                    {tableData.map((item, index) => (
                                        <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.mavg}</TableCell>
                                    ))}
                                </TableRow>

                                <TableRow>
                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Inw. Main Avg.</TableCell>
                                    {calculatedInwardAvg.map((item, index) => {
                                        const mainAvg = tableData[index]?.mavg; // Ensure there's a corresponding value
                                        const inwMainAvg = item;

                                        // Determine the color based on the comparison
                                        const textColor = inwMainAvg <= mainAvg ? 'green' : 'red';

                                        return (
                                            <TableCell key={index} sx={{ p: 1, border: '1px solid #000', color: textColor }} align='center'>
                                                {inwMainAvg.toFixed(2)}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>


                                {formData.m1cloth !== '0' &&
                                    <>
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>M1 Avg.</TableCell>
                                            {tableData.map((item, index) => (
                                                <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.m1avg}</TableCell>
                                            ))}
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Inw. M1 Avg.</TableCell>
                                            {calculatedInwardAvg1.map((item, index) => {
                                                const m1Avg = tableData[index]?.m1avg; // Ensure there's a corresponding value
                                                const inwM1Avg = item;

                                                // Determine the color based on the comparison
                                                const textColor = inwM1Avg <= m1Avg ? 'green' : 'red';

                                                return (
                                                    <TableCell key={index} sx={{ p: 1, border: '1px solid #000', color: textColor }} align='center'>
                                                        {inwM1Avg.toFixed(2)}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    </>
                                }

                                {formData.m2cloth !== '0' &&
                                    <>
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>M2 Avg.</TableCell>
                                            {tableData.map((item, index) => (
                                                <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.m2avg}</TableCell>
                                            ))}
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Inw. M2 Avg.</TableCell>
                                            {calculatedInwardAvg2.map((item, index) => {
                                                const m2Avg = tableData[index]?.m2avg; // Ensure there's a corresponding value
                                                const inwM2Avg = item;

                                                // Determine the color based on the comparison
                                                const textColor = inwM2Avg <= m2Avg ? 'green' : 'red';

                                                return (
                                                    <TableCell key={index} sx={{ p: 1, border: '1px solid #000', color: textColor }} align='center'>
                                                        {inwM2Avg.toFixed(2)}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    </>
                                }

                                {formData.m3cloth !== '0' &&
                                    <>
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>M3 Avg.</TableCell>
                                            {tableData.map((item, index) => (
                                                <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.m3avg}</TableCell>
                                            ))}
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Inw. M3 Avg.</TableCell>
                                            {calculatedInwardAvg3.map((item, index) => {
                                                const m3Avg = tableData[index]?.m3avg; // Ensure there's a corresponding value
                                                const inwM3Avg = item;

                                                // Determine the color based on the comparison
                                                const textColor = inwM3Avg <= m3Avg ? 'green' : 'red';

                                                return (
                                                    <TableCell key={index} sx={{ p: 1, border: '1px solid #000', color: textColor }} align='center'>
                                                        {inwM3Avg.toFixed(2)}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    </>
                                }
                            </Table>
                        </TableContainer>

                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
};

export default CuttingFinalPrint;
